/**
 * @description renders the Personnel Sync Administration page
 */

import React from 'react';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useParams, Link } from 'react-router-dom';

import BodyContainer from '@seccon/shared/ui/components/BodyContainer';
import TabContent from '@seccon/shared/ui/components/TabContent';

import History from './components/History';
import MappingDefinitions from './components/MappingDefinitions';
import { ActionsProvider } from './contexts/actions';

// History tab value
const HISTORY = 'history';

// Mapping Definitions tab value
const MAPPING_DEFINITIONS = 'mappingDefinitions';

// List of tabs
const TABS = [
  { id: HISTORY, label: 'History' },
  { id: MAPPING_DEFINITIONS, label: 'Mapping Definitions' }
];

// List of tab content
const TAB_CONTENT = [
  { id: HISTORY, Content: History },
  { id: MAPPING_DEFINITIONS, Content: MappingDefinitions }
];

const styles = {
  pageHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  tabContainer: {
    borderBottom: 1,
    borderColor: 'divider'
  }
};

const PersonnelSyncAdmin = () => {
  const { tabName } = useParams();

  // Contains a reference to the page header actions container. Its used by the tab content to inject
  // action buttons into the page header.
  const actionsRef = React.useRef(null);

  return (
    <BodyContainer>
      <Typography variant='h4' sx={styles.pageHeader}>
        Personnel Sync
        <Box ref={actionsRef} />
      </Typography>
      <ActionsProvider actionsRef={actionsRef}>
        <Tabs
          aria-label='Personnel sync admin tabs'
          centered
          sx={styles.tabContainer}
          value={tabName}
        >
          {TABS.map(({ id, label }) => (
            <Tab
              aria-controls={`tabpanel-${ id }`}
              component={Link}
              id={`tab-${ id }`}
              key={id}
              label={label}
              to={`../index/${ id }`}
              value={id}
            />
          ))}
        </Tabs>
        {TAB_CONTENT.map(({ id, Content }) => (
          <TabContent
            Content={Content}
            id={id}
            key={id}
            visible={tabName === id}
          />
        ))}
      </ActionsProvider>
    </BodyContainer>
  );
}

export default PersonnelSyncAdmin;
